import { ChangeDetectorRef, Component } from '@angular/core';
import { UserInfoService } from '../../spartacus/services/user-info.service';
import { MaterialsukModule } from '../materialsuk.module';
import { MaterialsUKService } from '../materialsuk-service';

@Component({
  selector: 'app-mymaterials-banner',
  standalone: false,
  templateUrl: './mymaterials-banner.component.html',
  styleUrl: './mymaterials-banner.component.scss'
})
export class MymaterialsBannerComponent {
  isLoading: boolean=false;
  seasonData: any;
  parameterobj:any;
  activeSeason: any;

  constructor(private userInfoService:UserInfoService,private materialsUkService:MaterialsUKService,private cd:ChangeDetectorRef){

  }

  ngOnInit(){
    this.materialsUkService.getMaterialsSeasonDropdown(" ").subscribe(data=>{
      this.seasonData=data;
      
      this.cd.detectChanges();
      let newObject = { ...this.parameterobj };
      newObject['season'] = this.seasonData?.defaultSeason
      this.parameterobj = newObject;
      this.activeSeason =this.seasonData?.defaultSeason;
      this.materialsUkService.sendMaterialDropdownValue(this.seasonData.defaultSeason);
    });
  }

  selectedSeason(e :any){ 
    
    this.isLoading=true;
    
    this.materialsUkService.sendMaterialDropdownValue((e.target as HTMLInputElement).value)
    this.materialsUkService.getMaterialsSeasonDropdown((e.target as HTMLInputElement).value).subscribe((res:any)=>{
      this.seasonData=res;
      this.isLoading=false;
      this.cd.detectChanges();
    }
   );
  }

}
